import { observer } from 'mobx-react-lite';
import PropTypes from 'prop-types';
import React from 'react';
import { RefactoredChartContainer } from '../../../charts/d3/candlestickchart/newCandleChart/chartContainer/RefactoredChartContainer';
import AlertChartHeader from '../../../charts/d3/candlestickchart/newCandleChart/chartHeader/AlertChartHeader';

export const AlertChartWrapper = observer(
  ({
    symbol,
    timeUnit,
    candleDuration,
    numberOfCandles,
    setters,
    showCandleNumbers,
    width,
    height,
    dataSource,
    brokerage,
    brokerageOptions,
    moduleId,
  }) => {
    let size = 230;
    if (width && height) {
      if (width + 1 > height) {
        size = height * 87;
      } else {
        size = width * 112;
      }
    }
    const tradePlanId = 'none';
    const type = 'alert';
    const startHour = 9;
    const startMin = 30;
    return (
      <div>
        <AlertChartHeader
          type={type}
          setters={setters}
          symbol={symbol}
          showCandleNumbers={showCandleNumbers}
          dataSource={dataSource}
          brokerage={brokerage}
          numberOfCandles={numberOfCandles}
          timeUnit={timeUnit}
          candleDuration={candleDuration}
          brokerageOptions={brokerageOptions}
        />
        {dataSource === 'LIVE' && !brokerage ? (
          <div
            style={{
              color: '#b9bcc3',
              display: 'grid',
              placeItems: 'center',
              height: size,
              textAlign: 'center',
            }}
          >
            Select a brokerage to load this chart.
          </div>
        ) : (
          <RefactoredChartContainer
            tradePlanId={tradePlanId}
            symbol={symbol}
            dataSource={dataSource}
            brokerage={brokerage}
            numberOfCandles={numberOfCandles}
            timeUnit={timeUnit}
            candleDuration={candleDuration}
            id={moduleId}
            size={size}
            margin={4}
            padding={30}
            showCandleNumbers={showCandleNumbers}
            startHour={startHour}
            startMin={startMin}
            setNumberOfCandles={setters.setNumberOfCandles}
          />
        )}
      </div>
    );
  }
);

AlertChartWrapper.propTypes = {
  brokerage: PropTypes.string,
  brokerageOptions: PropTypes.arrayOf(PropTypes.string),
  candleDuration: PropTypes.any,
  numberOfCandles: PropTypes.any,
  setters: PropTypes.any,
  showCandleNumbers: PropTypes.any,
  symbol: PropTypes.any,
  timeUnit: PropTypes.any,
  width: PropTypes.number,
  height: PropTypes.number,
  moduleId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};
